<template>
  <offer-sale-base :offer-sale="offerSale" :is-group="isGroup" type="percentage_offer_sales" :is-activable="isActivable">
    <template v-slot:line-1>
      <offer-sale-line :line-items="isGroup ? discountItem : productInfoItems" />
    </template>

    <template v-slot:line-2>
      <offer-sale-line :line-items="isGroup ? minMaxItems : discountItem">
        <user-consumption v-if="isGroup" :maximum-per-client="offerSale.maximum_per_client" :user-sale-consumption-amount="userSaleConsumptionAmountInGroup" />
      </offer-sale-line>
    </template>

    <template v-if="!isGroup" v-slot:line-3>
      <offer-sale-line :line-items="minMaxItems">
        <user-consumption :maximum-per-client="offerSale.maximum_per_client" :user-sale-consumption-amount="offerSale.user_sale_consumption_amount" />
      </offer-sale-line>
    </template>
  </offer-sale-base>
</template>

<script>
import OfferSaleBase from './OfferSaleBase.vue'
import OfferSaleLine from './OfferSaleLine.vue'
import UserConsumption from './UserConsumption.vue'

export default {
  name: 'PercentageOfferSale',
  components: {
    OfferSaleBase,
    OfferSaleLine,
    UserConsumption,
  },
  props: {
    offerSale: {
      type: Object,
      required: true,
    },
    isActivable: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isGroup() {
      return this.offerSale.percentage_offer_sales && this.offerSale.percentage_offer_sales.length > 0
    },
    userSaleConsumptionAmountInGroup() {
      return this.offerSale.percentage_offer_sales.reduce((acc, percentageOfferSale) => acc + percentageOfferSale.user_sale_consumption_amount, 0)
    },
    productInfoItems() {
      return [
        {
          label: 'SKU',
          value: this.offerSale.sku,
          format: 'text',
        },
        {
          label: 'EAN',
          value: this.offerSale.ean,
          format: 'text',
        },
      ]
    },
    discountItem() {
      return [
        {
          label: 'Desconto',
          value: this.offerSale.percentage_discount,
          format: 'percent',
        },
      ]
    },
    minMaxItems() {
      return [
        {
          label: 'Mín. CPF',
          value: this.offerSale.minimum_per_client,
          format: 'text',
        },
        {
          label: 'Máx. CPF',
          value: this.offerSale.maximum_per_client,
          format: 'text',
        },
      ]
    },
  },
}
</script>

<style lang="scss" scoped>
.red-consumption {
  color: $vermelho-0;
}
</style>
